<template>
  <v-content>
    <div 
      class="text-xs-center pt-5">
      <v-avatar 
        size="125px">
        <v-hover>
          <v-img
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 18 : 12}`"
            aspect-ratio="1"
            :src="friendProfile.profileImg">
          </v-img>
        </v-hover>

        <!-- <v-btn 
          style="transform: translate(46px, 46px); height: 30px; width: 30px;"
          absolute
          fab
          :ripple="false"
          dark
          color="blue darken-2"
          @click.prevent="">

          <v-icon 
            small>fas fa-account-check</v-icon>
          
        </v-btn> -->
        <app-buttons-friend-status
          :item="friendProfile"
          :my-friends="myFriends"
          :user="user"></app-buttons-friend-status>
      </v-avatar> 
      <v-layout
        style="max-width: 420px; margin: auto;"
        row 
        wrap
        justify-center>
        <v-flex 
          class="mt-3"
          xs12>
          <div class="caption font-italic grey--text">
            <v-icon size="14">
              fas fa-fingerprint
            </v-icon>
            {{ friendProfile.uniqueId }}
          </div>
        </v-flex>
        <v-flex 
          class="mt-3"
          xs12>
          <div class="headline">
            {{ firstname }}<span class="font-weight-bold">
              {{ lastname }}
            </span>
          </div>

          
          <!-- {{ friendProfile }} -->
        </v-flex>
         
          

        <v-flex 
          xs12>
          <div class="subheading grey--text pt-1 pb-3">
            {{ friendProfile.status }}
          </div>
        </v-flex>
        <v-flex 
          v-if="friendProfile.displayBD"
          xs12>
          <div class="subheading grey--text pt-1 pb-3">
            <v-icon
              icon-color="#9E9E9E">
              $vuetify.icons.birthdaycake
            </v-icon> {{ friendProfile.birthday | dateShort }}
          </div>
        </v-flex>
      </v-layout>

      

      
            
      <v-layout 
        v-if="allOrNoneCats"
        style="max-width: 420px; margin: auto;"
        align-center
        justify-space-between
        row
        wrap>
        <v-flex
          v-for="cat in orderedCategories"
          :key="cat.title"
          xs4>
          <v-btn 
            :color="cat.color" 
            style="width: 110px; cursor: default;" 
            class="text-capitalize"
            :ripple="false"
            depressed
            dark>
            <v-icon 
              class="mr-2"
            
              dark>
              {{ cat.icon }}
            </v-icon>
            {{ cat.title }}
          </v-btn>

          <!-- <v-chip 
            :color="cat.color" 
            style="width: 100px;" 
            label
            disabled 
            text-color="white">
            <v-icon 
              left 
              dark>{{ cat.icon }}</v-icon>{{ cat.title }}
          </v-chip> -->
        </v-flex>
      </v-layout>

      <v-layout 
        v-else
        style="max-width: 420px; margin: auto;"
        align-center
        justify-space-around
        row
        wrap>
        <template v-for="cat in orderedCategories">
          <v-flex
            v-if="friendProfile.filter.categories.includes(cat.title)"
            :key="cat.title"
            xs4>
            <v-btn 
            
              :color="cat.color" 
              style="width: 110px; cursor: default;" 
              class="text-capitalize"
              :ripple="false"

              depressed
              dark>
              <v-icon 
                class="mr-2"
                size="20px"
                dark>
                {{ cat.icon }}
              </v-icon>
              {{ cat.title }}
            </v-btn>

          <!-- <v-chip 
            :color="cat.color" 
            style="width: 100px;" 
            label
            disabled 
            text-color="white">
            <v-icon 
              left 
              dark>{{ cat.icon }}</v-icon>{{ cat.title }}
          </v-chip> -->
          </v-flex>
        </template>
      </v-layout>
            
      <!-- next upcoming event -->
      <app-profile-next-event v-if="path === '/timeline'">
      </app-profile-next-event>
    </div>
  </v-content>
</template>


<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { orderBy } from 'lodash'

import ButtonsFriendRequestProfile from '@/components/global_comps/FriendRequest/ButtonsFriendRequestProfile.vue'


import ProfileNextEvent from '@/components/View_Profile/ProfileNextEvent'


export default {
  components: {
    // eslint-disable-next-line
    'app-profile-next-event': ProfileNextEvent,
    // eslint-disable-next-line
    "app-buttons-friend-status": ButtonsFriendRequestProfile
  },
  data() {
    return {
      
      fab: false,
    }
  },
  
  computed: {
    ...mapState({
      user: state => state.user.user,
      path: state => state.route.path,
      isMobile: state => state.isMobile,
      categories: state => state.categories,
      myFriends: state => state.user.myFriends
      
    }),
    ...mapGetters({
      // user: 'user',
      loading: 'loading',
      friendProfile: 'friendProfile'
    }),

    allOrNoneCats() {
      let friendCats = this.friendProfile.filter.categories
      let allCategoriesAry = []
      for (const key of Object.keys(this.categories)) {
        allCategoriesAry.push(key)
      }

      return friendCats === null || friendCats === undefined || friendCats.length === 0 || friendCats.length === allCategoriesAry.length
    },

    orderedCategories() {
      return orderBy(this.categories, 'order')
    },
    firstname() {
      
      return this.friendProfile.name.substr(0,this.friendProfile.name.indexOf(' '))
      
    },
    lastname() {
      return this.friendProfile.name.substr(this.friendProfile.name.indexOf(' ')+1)
      
    },
    error () {
      return this.$store.getters.error
    }
   
  },
  created () {
    console.log('jetzt', this.$route.params)
    this.loadFriend(this.$route.params.uniqueId)

  },
  methods: {
    
    ...mapActions([
      'loadFriend',
    ]),
  },
 
}
</script>

<style scoped>

</style>
